import React from 'react'

const WhatsappButton = ({text, whatsAppPhoneNumber}) => {
    return (
        <a className='btn btn-primary'
            style={{ backgroundColor: "green" }}
            href={
                "https://api.whatsapp.com/send?phone=" + whatsAppPhoneNumber + "&text=" + text
            }
        >
            <i className="fa-brands fa-whatsapp fa-lg"></i>
        </a>
    )
}

export default WhatsappButton